export default {
  currentUser() {
    let userStr = window.localStorage.getItem("user");
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  },
};
